import { ApproveQuote } from './ApproveQuote';
import { SignQuote } from './SignQuote';
import { PayPolicy } from './PayPolicy';
import { FileClaim } from './FileClaim';
import { Support } from './Support';
import { AttestQuote } from './AttestQuote';
import { RenewReady } from './RenewReady';
import { RenewBound } from './RenewBound';

export default {
  ApproveQuote,
  SignQuote,
  PayPolicy,
  FileClaim,
  Support,
  AttestQuote,
  RenewReady,
  RenewBound,
};
